import { IBillingDetails } from "sharedFeatures/sharedServices/Responses/Subscription/IBillingDetails";

export class BillingDetails implements IBillingDetails{
    public Customer_ID: number = 0;
    public FirstName: string = '';
    public LastName: string = '';
    public CompanyName: string = '';
    public VatId: string = '';
    public Phone: string = '';
    public Address1: string = '';
    public Address2: string = '';
    public City: string = '';
    public Zip: string = '';
    public IsPrivateUser: boolean = false;
    public County: string = '';

    public Country_ID: number = 0;
    public Country_Name: string = '';
    public Country_HasVatID: boolean = false;

    constructor(billingDetails?: IBillingDetails){
        if (billingDetails !== undefined) {
            this.Customer_ID = billingDetails.Customer_ID;
            this.FirstName = billingDetails.FirstName;
            this.LastName = billingDetails.LastName;
            this.CompanyName = billingDetails.CompanyName;
            this.VatId = billingDetails.VatId;
            this.Phone = billingDetails.Phone;
            this.Address1 = billingDetails.Address1;
            this.Address2 = billingDetails.Address2;
            this.City = billingDetails.City;
            this.Zip = billingDetails.Zip;
            this.IsPrivateUser = billingDetails.IsPrivateUser;
            this.County = billingDetails.County;

            this.Country_ID = billingDetails.Country_ID;
            this.Country_Name = billingDetails.Country_Name;
            this.Country_HasVatID = billingDetails.Country_HasVatID;
        }
    }

    IsEqual(billingDetails: BillingDetails): boolean {
        return this.Customer_ID === billingDetails.Customer_ID &&
               this.FirstName === billingDetails.FirstName &&
               this.LastName === billingDetails.LastName &&
               this.CompanyName === billingDetails.CompanyName &&
               this.VatId === billingDetails.VatId &&
               this.Phone === billingDetails.Phone &&
               this.Address1 === billingDetails.Address1 &&
               this.Address2 === billingDetails.Address2 &&
               this.City === billingDetails.City &&
               this.Zip === billingDetails.Zip &&
               this.IsPrivateUser === billingDetails.IsPrivateUser &&
               this.County === billingDetails.County &&

               this.Country_ID === billingDetails.Country_ID &&
               this.Country_Name === billingDetails.Country_Name &&
               this.Country_HasVatID === billingDetails.Country_HasVatID;
    }
}
